// Translates text between some supported languages + some other language utilities
angular.module('translator').filter('translateTo', function translateToFilter(tgTranslate, $translate) {
	return function (input, langKey) {
		var currentLang = tgTranslate.getCurrentLanguage()
		tgTranslate.use(langKey)
		input = input || ''
		var out = $translate.instant(input) //$filter('translate')(input);
		tgTranslate.use(currentLang)
		return out
	}
})
